import React from 'react';
import { Input } from 'reactstrap';
import { Controller, FieldValues } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';

import { ICustomTextProps } from 'models/Form';
import './FormComponents.css';

export function ControlledNumberInput<T extends FieldValues>({
  fieldName,
  control,
  label,
  description,
  placeholder,
  rules,
  readonly,
}: ICustomTextProps<T>) {
  return (
    <Controller
      name={fieldName}
      control={control}
      rules={rules || {}}
      render={({ field, fieldState, formState }) => {
        const isValid: boolean =
          !fieldState.invalid && (fieldState.isTouched || formState.isSubmitted) && !readonly;
        const isInvalid: boolean =
          fieldState.invalid && (fieldState.isTouched || formState.isSubmitted) && !readonly;
        return (
          <>
            <span>{label}</span>
            <Input
              type="number"
              ref={field.ref}
              value={field.value as string}
              readOnly={readonly}
              valid={isValid}
              invalid={isInvalid}
              name={field.name}
              onBlur={field.onBlur}
              onChange={field.onChange}
              placeholder={placeholder || ''}
              disabled={readonly}
            />
            {description && <span className="field-description">{description}</span>}
          </>
        );
      }}
    />
  );
}
